import { makeAutoObservable } from 'mobx';
import { createObservableUser, createObservableUserFromAiAgent, UserModel } from './user';
import { InvitedUser } from '../interfaces/user';
import { AiAgent, RawWorkspace, WorkspaceApps } from '../interfaces/workspace';
import { TabsStore } from '../stores/tabsStore';

export class WorkspaceModel {
  // Common
  id: string;
  name: string;
  email?: string | null;
  isAdmin: boolean;
  isOwner: boolean;

  // Relational
  invitedUsers: InvitedUser[];
  users: UserModel[];
  customerId?: string | null;
  customerRole?: number | null;

  // Others
  industry: string;
  apps: WorkspaceApps;
  teamType: number;
  phone?: string | null;
  logoUrl?: string | null;
  aiAgents: AiAgent[] = [];
  tabsStore: TabsStore = new TabsStore();

  constructor(rawWorkspace: RawWorkspace) {
    makeAutoObservable(this);

    this.id = rawWorkspace.id;
    this.name = rawWorkspace.name;
    this.email = rawWorkspace.email;
    this.isAdmin = rawWorkspace.isAdmin;
    this.isOwner = rawWorkspace.isOwner;
    this.invitedUsers = rawWorkspace.invitedUsers;

    const regularUsers = rawWorkspace.users?.map((user) => createObservableUser(user));
    this.aiAgents = rawWorkspace.aiAgents || [];

    const activeAgents = this.aiAgents.filter((agent) => agent.isActive);
    const aiUsers = activeAgents.map(createObservableUserFromAiAgent);

    this.users = [...(regularUsers || []), ...(aiUsers || [])];

    this.customerId = rawWorkspace.customerId;
    this.customerRole = rawWorkspace.customerRole;
    this.industry = rawWorkspace.industry;
    this.apps = rawWorkspace.apps;
    this.teamType = rawWorkspace.teamType;
    this.phone = rawWorkspace.phone;
    this.logoUrl = rawWorkspace.logoUrl;
  }

  // get viewTasks() {
  //   // Add filtering logic based on current filter

  //   const tasks = rootStore.taskStore.tasks.filter((task) => !task.parentTaskId);

  //   if (!this.currentView || !this.currentView.filters) {
  //     return tasks;
  //   }

  //   return filterTasks(tasks, this.currentView.filters);
  // }

  // *updateViewsFromFirebase() {
  //   this.views = (yield getUserWorkspacePreferenceData('views')) ?? [];
  // }

  // setCurrentView(viewId: string) {
  //   this.currentView = this.views.find((view) => view.id === viewId) ?? null;
  // }

  enableAgent(agentId: string) {
    const agent = this.aiAgents.find((agent) => agent.id === agentId);
    if (!agent) {
      return;
    }

    agent.isActive = true;

    const aiUser = createObservableUserFromAiAgent(agent);
    this.users.push(aiUser);
  }

  disableAgent(agentId: string) {
    const agent = this.aiAgents.find((agent) => agent.id === agentId);
    if (!agent) {
      return;
    }

    agent.isActive = false;
    this.users = this.users?.filter((user) => user.id !== agentId);
  }
}

export const createObservableWorkspace = (rawWorkspace: RawWorkspace) => {
  return new WorkspaceModel(rawWorkspace);
};
